import { ANALITICS_ID } from 'Constants'

type ClickEvent = {
  eventName: 'click'
  params: {
    id: string
  }
}

type ErrorEvent = {
  eventName: 'extension_error'
  params: {
    errorCode: string
    contentLength?: number
  }
}

type ChooseEmotionEvent = {
  eventName: 'choose_emotion'
  params: {
    emotion: string
  }
}

type SelectLangEvent = {
  eventName: 'select_lang'
  params: {
    lang: string
  }
}

type AnaliticsEvent = ClickEvent | ErrorEvent | ChooseEmotionEvent | SelectLangEvent

export function initAnalitics() {}

function sendAnaliticsEvent({ eventName, params }: AnaliticsEvent) {
  if (import.meta.env.MODE !== 'production') {
    console.log('Analitics event:', eventName, params)
    return
  }

  window.gtag('event', eventName, {
    ...params,
    page_url: window.location.href,
    send_to: ANALITICS_ID,
    cookie_flags: 'samesite=none;secure',
  })
}

export function sendClickAnaliticsEvent(id: ClickEvent['params']['id']) {
  sendAnaliticsEvent({
    eventName: 'click',
    params: {
      id,
    },
  })
}

export function sendErrorAnaliticsEvent(errorCode: string, contentLength?: number) {
  const params: ErrorEvent['params'] = contentLength ? { errorCode, contentLength } : { errorCode }

  sendAnaliticsEvent({
    eventName: 'extension_error',
    params,
  })
}

export function sendChooseEmotionEvent(params: ChooseEmotionEvent['params']) {
  sendAnaliticsEvent({
    eventName: 'choose_emotion',
    params,
  })
}

export function sendSelectLangEvent(params: SelectLangEvent['params']) {
  sendAnaliticsEvent({
    eventName: 'select_lang',
    params,
  })
}
